import { devtools } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

interface IPhoneCountriesStore {
  isPhoneCountriesOpen: boolean;
  isPhoneCountryClicked: boolean;
  setIsPhoneCountriesOpen: (isCountriesOpen: boolean) => void;
  setIsPhoneCountryClicked: (isPhoneCountryClicked: boolean) => void;
}

export const usePhoneCountriesStore =
  createWithEqualityFn<IPhoneCountriesStore>()(
    devtools(
      (set) => ({
        isPhoneCountriesOpen: false,
        isPhoneCountryClicked: false,
        setIsPhoneCountriesOpen: (isPhoneCountriesOpen: boolean) => {
          set({ isPhoneCountriesOpen });
        },
        setIsPhoneCountryClicked: (isPhoneCountryClicked: boolean) => {
          set({ isPhoneCountryClicked });
        },
      }),
      { name: "Phone Countries Store" },
    ),
    shallow,
  );
